import React, { useMemo } from "react";
import { PermissionContext, PermissionAPI } from "@amzn/msa-static-website-development";
import { usePermission } from "../hooks/usePermission";

export const PermissionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { hasPermission, hasDataPermission, hasDataScopeCoverage } = usePermission();

  const value = useMemo<PermissionAPI>(
    () => ({ hasPermission, hasDataPermission, hasDataScopeCoverage }),
    [hasPermission, hasDataPermission, hasDataScopeCoverage]
  );

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
};
